<template>
  <div>
    <h2 class="m-b-20 section-title">{{ label }}</h2>
    <div class="card m-b-40">
      <div class="row">
        <div>
          <GoodsType
            :value="2"
            @activeGoodsType="activeGoodsType"
          />
        </div>
        <div class="col-xs-1" v-if="showColliAmount">
          <InputText
            :label="$t('colli')"
            v-model="value.colli"
            :options="numbers"
            :rules="{required: true}"/>
        </div>
        <div :class="showColliAmount ? 'col-xs-3' : 'col-xs-4'">
          <NestedSelect
            v-if="get_parcel_types[2] != null"
            :label="$t('packaging')"
            @parcelTypeSelected="parcelTypeSelected"
            :getter="get_parcel_types[2]"
            v-model="value.parcelType" />
        </div>
        <div class="col-xs-6">
          <DimensionsSelect
            v-model="value.dimensions" />
        </div>
        <div class="col-xs-2">
          <WeightSelect
            :label="`${$t('weight_per')} ${$t('colli').toLocaleLowerCase()}`"
            v-model="value.colliWeight"
            :rules="{required: true}"/>
        </div>
      </div>
      <div class="separator" v-if="removable"></div>
      <div class="clear-float" v-if="removable">
        <Btn
          @click.native="removeDocument"
          class="gray float-left m-r-20"
          :icon="{
            name: 'deleteForever',
            size: '16',
          }"
          :btnText="$t('Remove document')"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import mixin from '@/mixins/mixins.js';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import NestedSelect from '@/components/elements/inputs/nestedSelect.vue';
import DimensionsSelect from '@/components/elements/inputs/dimensionsSelect.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";

import ContentRow from "@/components/shipments/contentRow.vue";
import GoodsType from "@/components/shipments/goodsType.vue";

export default {
  name: 'DocumentBlock',
  mixins: [mixin],
  components: {
    GoodsType,
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    ContentRow,
    NestedSelect,
  },
  props: {
     label: {
      type: String,
      default: 'Document',
    },
    removable: {
      type: Boolean,
      default: false,
    },
    showColliAmount: {
      type: Boolean,
      default: false,
    },
    showColliContent: {
      type: Boolean,
      default: false,
    },
    customId: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => {
        return {
          goodsType: 2,
          colli: 1,
          parcelType: '',
          packagingName: '',
          colliWeight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: '',
          },
        };
      },
    },
  },
  computed: {
    ...mapGetters([
      'get_parcel_types',
    ]),
  },
  methods: {
    parcelTypeSelected(val) {
      //Should not be executed on copy or draft shipment initially, only when user change packaging value
      this.$emit('input', {
        ...this.value,
        parcelType: val.name,
        packagingName: val.packagingName,
        //Give advantage to predifined values on user change
        dimensions: {
          width: {
            value: val.width ? val.width : this.value.dimensions.width.value,
            disabled: false,
          },
          height: {
            value: val.height ? val.height : this.value.dimensions.height.value,
            disabled: false,
          },
          length: {
            value: val.length ? val.length : this.value.dimensions.length.value,
            disabled: false,
          },
          dimensionsType: val.dimension_measure ? val.dimension_measure : this.value.dimensions.dimensionsType
        },
        colliWeight: {
          value: val.weight ? val.weight : this.value.colliWeight.value,
          unit: val.weight_measure ? val.weight_measure : this.value.colliWeight.unit,
        },
      });
    },
    removeDocument() {
      this.$emit('removeDocument')
    },
    activeGoodsType(val) {
      this.$emit('activePackageGoodsType', val);
    },
  },
}
</script>
